import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class MantenedorUsuariosService {
    constructor(private http: HttpClient) { }

    /*
    trae TODOS los usuario del backend
    */
    traeUsuarios() {
        return this.http.get(`${environment.urlApiUsuario}/afiliados`, { headers: this.armaCabecera() }).toPromise()
    }
    usuarioBuscador(buscador: any, rutEnvio: any) {

        return this.http.post(`${environment.urlApiUsuario}/usuario/buscador/`,
            {
                mail: buscador?.correo.trim(),
                rut: rutEnvio
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    traeComunas(idRegion: any) {
        return this.http.get(`${environment.urlApiUsuario}/comunas/${idRegion}`, { headers: this.armaCabecera() }).toPromise()
    }

    traeRegiones() {
        return this.http.get(`${environment.urlApiUsuario}/regiones`, { headers: this.armaCabecera() }).toPromise()
    }

    traeEstadoCivil() {
        return this.http.get(`${environment.urlApiUsuario}/estado-civil`, { headers: this.armaCabecera() }).toPromise()
    }

    traePrevision() {
        return this.http.get(`${environment.urlApiUsuario}/prevision`, { headers: this.armaCabecera() }).toPromise()
    }
    traeSistemaSalud() {
        return this.http.get(`${environment.urlApiUsuario}/sistema-salud`, { headers: this.armaCabecera() }).toPromise()
    }

    traeRoles() {
        return this.http.get(`${environment.urlApiUsuario}/roles`, { headers: this.armaCabecera() }).toPromise()
    }

    creaUsuario(usuario: any) {
        return this.http.post(`${environment.urlApiUsuario}/usuarios`,
            {
                nombres: usuario.nombres,
                apellidoMaterno: usuario.apellidoMaterno,
                apellidoPaterno: usuario.apellidoPaterno,
                mail: usuario.correo,
                rut: usuario.rut.split('-')[0],
                dv: usuario.rut.split('-')[1],
                estado: usuario.estadoAfiliado,
                telefonoFijo: usuario.fonoFijo,
                telefonoMovil: usuario.fonoMovil,
                tipoAfiliado: usuario.tipoAfiliado,
                fechaAfiliado: usuario.fechaIngreso,
                fechaNacimiento: usuario.fechaNacimiento,
                idEstadoCivil: usuario.estadoCivil,
                idPrevision: usuario.prevision,
                idsistemaSalud: usuario.sistemaSalud,
                idSexo: usuario.sexo,
                idEjecutivo: usuario.idEjecutivo,
                direccionParticular: {
                    descripcion: usuario.direccion.descripcion,
                    descripcionAdicional: usuario.direccion.descripcionAdicional,
                    numero: usuario.direccion.numero,
                    idComuna: usuario.direccion.comuna,
                    idRegion: usuario.direccion.region,
                },
                //  roles: [ { id: usuario.rol } ],
                roles: usuario.rol,
                datosLaborales: {
                    tipoUnidad: usuario.datosLaborales.tipoUnidad,
                    unidad: usuario.datosLaborales.unidad,
                    calidadJuridica: usuario.datosLaborales.calidadJuridica,
                    estamento: usuario.datosLaborales.estamento,
                    direccion: {
                        descripcion: usuario.datosLaborales.direccion.descripcion,
                        descripcionAdicional: usuario.datosLaborales.direccion.descripcionAdicional,
                        numero: usuario.datosLaborales.direccion.numero,
                        idComuna: usuario.datosLaborales.direccion.comuna,
                        idRegion: usuario.datosLaborales.direccion.region
                    }
                }
            },
            { headers: this.armaCabecera() }).toPromise()
    }

    traerUsuario(idUsuario: any) {
        return this.http.get(`${environment.urlApiUsuario}/afiliados/${idUsuario}`,
            { headers: this.armaCabecera() }).toPromise();
    }




    editarUsuario(usuario: any) {
        return this.http.put(`${environment.urlApiUsuario}/usuarios`,
            {
                id: usuario.id,
                nombres: usuario.nombres,
                apellidoMaterno: usuario.apellidoMaterno,
                apellidoPaterno: usuario.apellidoPaterno,
                mail: usuario.correo,
                rut: usuario.rut.split('-')[0],
                dv: usuario.rut.split('-')[1],
                estado: usuario.estadoAfiliado,
                telefonoFijo: usuario.fonoFijo,
                telefonoMovil: usuario.fonoMovil,
                tipoAfiliado: usuario.tipoAfiliado,
                fechaAfiliado: usuario.fechaIngreso,
                fechaNacimiento: usuario.fechaNacimiento,
                idEstadoCivil: usuario.estadoCivil,
                idPrevision: usuario.prevision,
                idsistemaSalud: usuario.sistemaSalud,
                idSexo: usuario.sexo,
                idEjecutivo: usuario.idEjecutivo,
                direccionParticular: {
                    id: usuario.direccion.id,
                    descripcion: usuario.direccion.descripcion,
                    descripcionAdicional: usuario.direccion.descripcionAdicional,
                    numero: usuario.direccion.numero,
                    idComuna: usuario.direccion.comuna,
                    idRegion: usuario.direccion.region,
                },
                roles: usuario.rol,
                datosLaborales: {
                    id: usuario.datosLaborales.id,
                    tipoUnidad: usuario.datosLaborales.tipoUnidad,
                    unidad: usuario.datosLaborales.unidad,
                    calidadJuridica: usuario.datosLaborales.calidadJuridica,
                    estamento: usuario.datosLaborales.estamento,
                    direccion: {
                        id: usuario.datosLaborales.direccion.id,
                        descripcion: usuario.datosLaborales.direccion.descripcion,
                        descripcionAdicional: usuario.datosLaborales.direccion.descripcionAdicional,
                        numero: usuario.datosLaborales.direccion.numero,
                        idComuna: usuario.datosLaborales.direccion.comuna,
                        idRegion: usuario.datosLaborales.direccion.region
                    }
                }
            },
            { headers: this.armaCabecera() }).toPromise()
    }

    modificarEstado(idUsuario: any, estadoAfiliado: any) {
        return this.http.put(`${environment.urlApiUsuario}/usuarios`,
            { id: idUsuario, estado: estadoAfiliado }, { headers: this.armaCabecera() }).toPromise();
    }

    armaCabecera() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}
